import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import candidateicon from "../../assets/banners/topicon.png";

const LikedCandidatesStyled = () => {
  const [likedCandidates, setLikedCandidates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const { id } = useParams();
  const { t, i18n } = useTranslation();

  const userData = JSON.parse(localStorage.getItem("user"));
  const userId = id || userData?.id;

  // 🔹 Опции для сервиса (как в TopCandidates)
  const options = [
    { key: "offer_services", label: t("offerservices") },
    { key: "search_work", label: t("searchworktitle") },
  ];

  // 🔹 Карта сфер (как в TopCandidates) - human-readable → sphere_0, sphere_1 ...
  const sphereMap = {};
  const filters = t("filtres", { returnObjects: true }) || [];
  filters.forEach((name, i) => {
    sphereMap[name] = `sphere_${i}`;
  });

  useEffect(() => {
    if (!userId) {
      setLoading(false);
      setError("Пользователь не найден");
      return;
    }

    const fetchLikedCandidates = async () => {
      try {
        const response = await fetch(`/api/get_liked_candidates.php?liked_by=${userId}`);
        const text = await response.text();
        
        let data;
        try {
          data = JSON.parse(text);
        } catch (parseError) {
          console.error("JSON parse error:", parseError);
          setError("Ошибка формата данных от сервера");
          setLikedCandidates([]);
          return;
        }
        
        if (data.success && Array.isArray(data.candidates)) {
          setLikedCandidates(data.candidates);
          setError("");
        } else {
          setLikedCandidates([]);
          setError(data.message || "Нет данных");
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setError("Ошибка подключения к серверу");
        setLikedCandidates([]);
      } finally {
        setLoading(false);
      }
    };

    fetchLikedCandidates();
  }, [userId]);

  if (loading) {
    return <p className="text-center py-10 text-gray-500">{t("Loading...")}</p>;
  }

  if (error) {
    return (
      <section className="p-0">
        <h1 className="text-4xl mt-3 max-lg:text-xl px-6 font-bold text-white uppercase">
          {t("Candidates")}
        </h1>
        <div className="p-6">
          <p className="text-center py-10 text-red-500 text-xl">
            {error}
          </p>
        </div>
      </section>
    );
  }

  if (!likedCandidates || likedCandidates.length === 0) {
    return (
      <section className="p-0">
        <h1 className="text-4xl m-6 max-lg:text-xl px-6 font-bold text-white uppercase">
          {t("Candidates")}
        </h1>
        <div className="p-6">
          <p className="text-center py-10 text-white text-xl">
            {t("NoSavedCandidates")}
          </p>
        </div>
      </section>
    );
  }

  return (
    <section className="p-6 opacity-0 animate-[showtitle_1s_forwards]">
      <h1 className="text-4xl mt-3 max-lg:text-xl opacity-0 animate-[showtitle_1s_forwards]  px-6 font-bold text-white uppercase">
        {t("Candidates")}
      </h1>

      {/* 🔹 Список кандидатов в том же стиле как TopCandidates */}
      <div className="w-full mt-6 flex flex-wrap justify-start  p-6 max-md:p-3 gap-6">
        {likedCandidates.map((candidate) => (
          <Link
            to={`/ViewCandidatePage/${candidate.id}`}
            key={candidate.id}
            className="w-[410px] relative max-md:w-full p-2 bg-white transition-all hover:scale-105 flex justify-start rounded-xl items-center shadow-lg"
          >
            <div className="relative">
              <img
                src={
                  candidate.photo
                    ? `/api/uploads/${candidate.photo}`
                    : "https://cdn-icons-png.flaticon.com/512/847/847969.png"
                }
                alt={`${candidate.name} ${candidate.lastName}`}
                className="min-w-[100px] h-[100px] bg-gray-300 shadow-2xl rounded-xl object-cover"
              />
            </div>
            <div className="p-4 flex flex-col items-start gap-2 text-start">
              {/* 🔹 Имя и фамилия */}
              <h2 className="text-2xl max-sm:text-xl font-semibold text-[#006674]">
                {candidate.name} {candidate.lastName}
              </h2>

              {/* 🔹 Сервис */}
              {candidate.serviceType && (
                <span className="text-md max-sm:text-sm text-left font-medium text-gray-600">
                  {options.find(
                    (opt) => opt.key === candidate.serviceType
                  )?.label || candidate.serviceType}
                  {i18n.language === "am" ? "`" : ":"}
                </span>
              )}

             
              {/* 🔹 Сфера */}
              {(candidate.mainSphere || candidate.additionalSphere) && (
                <span className="text-sm text-gray-500">
                  {Object.keys(sphereMap).find(
                    (key) =>
                      sphereMap[key] === candidate.mainSphere ||
                      sphereMap[key] === candidate.additionalSphere
                  )}
                </span>
              )}

            
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default LikedCandidatesStyled;